import { LazyLoadComponent } from '@src/components';
import { lazy } from 'react';

const ESimsPage = lazy(() =>
  import('@src/pages/Dashboard').then((module) => ({
    default: module.MyEsims,
  }))
);

export function ESimsContainer() {
  return <LazyLoadComponent Component={<ESimsPage />} />;
}
